module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value) ? _c('div', [_c('div', [_c('label', {
    attrs: {
      "for": "commodity"
    }
  }, [_vm._v(" Commodity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.commodityToEdit.commodity),
      expression: "value.commodityToEdit.commodity"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "commodity",
      "autocomplete": "new-password",
      "preselect": "",
      "type": "text",
      "required": "",
      "placeholder": "Enter commodity name"
    },
    domProps: {
      "value": (_vm.value.commodityToEdit.commodity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.commodityToEdit, "commodity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('uiv-typeahead', {
    attrs: {
      "target": "#commodity",
      "async-src": _vm.getCommoditySearchUrl()
    },
    model: {
      value: (_vm.value.commodityToEdit.commodity),
      callback: function($$v) {
        _vm.$set(_vm.value.commodityToEdit, "commodity", $$v)
      },
      expression: "value.commodityToEdit.commodity"
    }
  })], 1), _vm._v(" "), _c('label', {
    attrs: {
      "for": "units"
    }
  }, [_vm._v(" Units")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.commodityToEdit.units),
      expression: "value.commodityToEdit.units"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "units",
      "autocomplete": "new-password",
      "preselect": "",
      "type": "text",
      "required": "",
      "placeholder": "Enter units"
    },
    domProps: {
      "value": (_vm.value.commodityToEdit.units)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.commodityToEdit, "units", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('uiv-typeahead', {
    attrs: {
      "target": "#units",
      "async-src": _vm.getUnitsSearchUrl()
    },
    model: {
      value: (_vm.value.commodityToEdit.units),
      callback: function($$v) {
        _vm.$set(_vm.value.commodityToEdit, "units", $$v)
      },
      expression: "value.commodityToEdit.units"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "linkPropertiesEdit"
    }
  }, [_vm._v("Properties (optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.linkProps),
      expression: "value.linkProps"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "linkPropertiesEdit",
      "placeholder": "Enter properties e.g. Sulphur=0.2,Zinc=0.1 (optional)"
    },
    domProps: {
      "value": (_vm.value.linkProps)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "linkProps", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d976a274", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d976a274"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/select-commodity-dialog/select-commodity-dialog.vue.html
// module id = 1132
// module chunks = 0